module.exports = "shrink-arrows"